(() => {
  console.log('SGR script loaded');

  const SGR_VARIANT_ID = 57090894365054;
  const BOTTLES_PER_CASE = 6;
  const SGR_TITLE = 'SGR';
  const SGR_RELOAD_KEY = 'sgr_cart_reload_done';

  let syncing = false;
  let queued = false;
  let mutationTimer = null;

  async function getCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    return await res.json();
  }

  function calculateSGR(cart) {
    let bottleCount = 0;
    let sgrQty = 0;

    cart.items.forEach(item => {
      if (Number(item.variant_id) === Number(SGR_VARIANT_ID)) {
        sgrQty += item.quantity;
        return;
      }

      const isIndividualBottle = item.properties && item.properties._Sursa === 'Somelier Virtual';

bottleCount += isIndividualBottle
  ? item.quantity
  : item.quantity * BOTTLES_PER_CASE;
    });

    return {
      required: bottleCount,
      current: sgrQty
    };
  }

  async function addSGR(qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: SGR_VARIANT_ID,
            quantity: qty
          }
        ]
      })
    });
  }

  async function changeSGRByKey(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: qty
      })
    });
  }

  function getCartItems() {
    return document.querySelectorAll('.cart-item');
  }

  function getItemTitleElement(item) {
    return item.querySelector('.cart-item__name, .h4.break, .cart-item__name.h4');
  }

  function isSGRItemElement(item) {
    const title = getItemTitleElement(item);
    if (!title) return false;

    return title.textContent.trim().includes(SGR_TITLE);
  }

  function moveSGRLast() {
    const cartItems = getCartItems();
    const sgrItems = [];

    cartItems.forEach(item => {
      if (isSGRItemElement(item)) {
        sgrItems.push(item);
      }
    });

    sgrItems.forEach(item => {
      const parent = item.parentNode;
      if (parent) {
        parent.appendChild(item);
      }
    });
  }

  function lockSGRControls() {
    const cartItems = getCartItems();

    cartItems.forEach(item => {
      if (!isSGRItemElement(item)) return;

      const quantityWrapper = item.querySelector('.quantity');
      const quantityButtons = item.querySelectorAll('.quantity__button');
      const quantityInput = item.querySelector('.quantity__input');
      const removeButton = item.querySelector('cart-remove-button, .cart-remove-button');
      const removeLink = item.querySelector('a[href*="/cart/change"]');

      if (quantityWrapper) {
        quantityWrapper.style.pointerEvents = 'none';
        quantityWrapper.style.opacity = '0.6';
      }

      quantityButtons.forEach(button => {
        button.disabled = true;
        button.style.pointerEvents = 'none';
      });

      if (quantityInput) {
        quantityInput.readOnly = true;
        quantityInput.disabled = true;
        quantityInput.style.pointerEvents = 'none';
      }

      if (removeButton) {
        removeButton.style.display = 'none';
      }

      if (removeLink) {
        removeLink.style.display = 'none';
      }
    });
  }

  function refreshSGRUI() {
    moveSGRLast();
    lockSGRControls();
  }

  function reloadCartPageOnce() {
    if (!window.location.pathname.includes('/cart')) return;
    if (sessionStorage.getItem(SGR_RELOAD_KEY) === '1') return;

    sessionStorage.setItem(SGR_RELOAD_KEY, '1');
    window.location.reload();
  }

  function clearReloadFlagIfStable(required, current) {
    if (required === current) {
      sessionStorage.removeItem(SGR_RELOAD_KEY);
    }
  }

  async function syncSGR() {
    if (syncing) {
      queued = true;
      return;
    }

    syncing = true;

    try {
      const cart = await getCart();
      const { required, current } = calculateSGR(cart);

      const sgrItem = cart.items.find(
        item => Number(item.variant_id) === Number(SGR_VARIANT_ID)
      );

      if (required === current) {
        clearReloadFlagIfStable(required, current);

        setTimeout(() => {
          refreshSGRUI();
        }, 40);

        return;
      }

      if (required <= 0) {
        if (sgrItem) {
          await changeSGRByKey(sgrItem.key, 0);
        }
      } else if (!sgrItem) {
        await addSGR(required);
      } else {
        await changeSGRByKey(sgrItem.key, required);
      }

      reloadCartPageOnce();

      refreshSGRUI();

      setTimeout(() => {
        refreshSGRUI();
      }, 40);

      setTimeout(() => {
        scheduleSync(60);
      }, 60);
    } catch (e) {
      console.log('SGR sync error', e);
    } finally {
      syncing = false;

      if (queued) {
        queued = false;
        syncSGR();
      }
    }
  }

  function scheduleSync(delay = 20) {
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(() => {
      syncSGR();

      setTimeout(() => {
        refreshSGRUI();
      }, 40);
    }, delay);
  }

  function isCartRequest(url) {
    if (!url) return false;

    return (
      url.includes('/cart/add') ||
      url.includes('/cart/update') ||
      url.includes('/cart/change') ||
      url.includes('/cart/clear') ||
      url.includes('/cart.js')
    );
  }

  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

      if (isCartRequest(url) && !url.includes('/cart.js')) {
        scheduleSync(10);
        setTimeout(() => scheduleSync(40), 40);
        setTimeout(() => refreshSGRUI(), 60);
      }
    } catch (e) {
      console.log('SGR fetch hook error', e);
    }

    return response;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._sgrUrl = url;
    return originalOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function(body) {
    this.addEventListener('load', () => {
      try {
        if (isCartRequest(this._sgrUrl) && !String(this._sgrUrl).includes('/cart.js')) {
          scheduleSync(10);
          setTimeout(() => scheduleSync(40), 40);
          setTimeout(() => refreshSGRUI(), 60);
        }
      } catch (e) {
        console.log('SGR xhr hook error', e);
      }
    });

    return originalSend.call(this, body);
  };

  const cartObserver = new MutationObserver(() => {
    scheduleSync(30);

    setTimeout(() => {
      refreshSGRUI();
    }, 40);
  });

  function startObserver() {
    const targets = [
      document.querySelector('cart-drawer'),
      document.querySelector('#CartDrawer'),
      document.querySelector('#main-cart-items'),
      document.querySelector('.cart-drawer')
    ].filter(Boolean);

    targets.forEach(target => {
      cartObserver.observe(target, {
        childList: true,
        subtree: true
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    startObserver();
    scheduleSync(20);

    setTimeout(() => {
      scheduleSync(80);
      refreshSGRUI();
    }, 80);

    setTimeout(() => {
      refreshSGRUI();
    }, 200);
  });

  document.addEventListener('change', e => {
    if (
      e.target.matches('.quantity__input') ||
      e.target.matches('input[name="updates[]"]')
    ) {
      scheduleSync(10);
      setTimeout(() => scheduleSync(40), 40);
    }
  });

  document.addEventListener('click', e => {
    if (
      e.target.closest('button[name="add"]') ||
      e.target.closest('.quantity__button') ||
      e.target.closest('cart-remove-button') ||
      e.target.closest('[data-cart-remove]')
    ) {
      scheduleSync(10);
      setTimeout(() => scheduleSync(40), 40);
    }
  });
})();